import { Pagination } from 'projects/access-control/src/app/Domain/Entities/pagination.interface';
import { IPkSk } from 'projects/access-control/src/app/Domain/Entities/roles/role.interface';
import { UsersGroups } from 'projects/access-control/src/app/Domain/Entities/userGroups.interface';
import { createAction, props } from '@ngrx/store';

export const getUser = createAction('[USER] Get user ', props<{ paginationTo: number }>());
export const getUserSuccess = createAction(
	'[USER] Get user success',
	props<{ user: UsersGroups[]; pagination: Pagination }>()
);
export const getUserError = createAction('[USER] Get user error', props<{ error: any }>());

export const searchUser = createAction('[USER] Search user ', props<{ url: string }>());
export const searchUserSuccess = createAction(
	'[USER] Search user success',
	props<{ user: UsersGroups[]; pagination: Pagination }>()
);
export const searchUserError = createAction('[USER] Search user error', props<{ error: any }>());

export const deleteUser = createAction('[USER] Delete user ', props<{ user: string[] }>());
export const deleteUserSuccess = createAction(
	'[USER] Delete user success',
	props<{ user: UsersGroups[] }>()
);
export const deleteUserError = createAction('[USER] Delete user error', props<{ error: any }>());

export const postUser = createAction('[USER] Post user ', props<{ user: UsersGroups }>());
export const postUserSuccess = createAction(
	'[USER] Post user success',
	props<{ user: UsersGroups }>()
);
export const postUserError = createAction('[USER] Post user error', props<{ error: any }>());

export const updateUser = createAction(
	'[USER] Update user ',
	props<{ user: UsersGroups; ids: IPkSk }>()
);
export const updateUserSuccess = createAction(
	'[USER] Update user success',
	props<{ user: UsersGroups }>()
);
export const updateUserError = createAction('[USER] Update user error', props<{ error: any }>());
